// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConfirmNicheAction .descriptionText {
  font-size: 18px;
}
.ConfirmNicheAction .confirmationText {
  font-size: 24px;
  margin: 12px 0px;
}
.ConfirmNicheAction .buttonsSection {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/modules/niche/confirm-niche-action/confirm-niche-action.styles.scss"],"names":[],"mappings":"AACE;EACE,eAAA;AAAJ;AAGE;EACE,eAAA;EACA,gBAAA;AADJ;AAIE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAFJ","sourcesContent":[".ConfirmNicheAction {\n  .descriptionText {\n    font-size: 18px;\n  }\n\n  .confirmationText {\n    font-size: 24px;\n    margin: 12px 0px;\n  }\n\n  .buttonsSection {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    margin-top: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
